// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32WnX","content":"styles_content__1HV7I"};